export const ASSOCIATED_CAMPAIGN_DSAP_MAPPING_RESET_STATE = 'ASSOCIATED_CAMPAIGN_DSAP_MAPPING_RESET_STATE';
export const ASSOCIATED_CAMPAIGN_DSAP_MAPPING_CURRENT_ITEM = 'ASSOCIATED_CAMPAIGN_DSAP_MAPPING_CURRENT_ITEM';

export const ASSOCIATED_CAMPAIGN_DSAP_MAPPING_REQUEST_LOADING = 'ASSOCIATED_CAMPAIGN_DSAP_MAPPING_REQUEST_LOADING';
export const ASSOCIATED_CAMPAIGN_DSAP_MAPPING_REQUEST_SUCCESS = 'ASSOCIATED_CAMPAIGN_DSAP_MAPPING_REQUEST_SUCCESS';
export const ASSOCIATED_CAMPAIGN_DSAP_MAPPING_REQUEST_FAILED = 'ASSOCIATED_CAMPAIGN_DSAP_MAPPING_REQUEST_FAILED';

export const ASSOCIATED_CAMPAIGN_DSAP_MAPPING_CURRENT_ACTION = 'ASSOCIATED_CAMPAIGN_DSAP_MAPPING_CURRENT_ACTION';
export const ASSOCIATED_CAMPAIGN_DSAP_MAPPING_RESET_ACTION = 'ASSOCIATED_CAMPAIGN_DSAP_MAPPING_RESET_ACTION';